import { render, staticRenderFns } from "./ChangelogCreate.vue?vue&type=template&id=112e96ad&scoped=true&lang=pug&"
import script from "./ChangelogCreate.vue?vue&type=script&lang=js&"
export * from "./ChangelogCreate.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogCreate.vue?vue&type=style&index=0&id=112e96ad&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e96ad",
  null
  
)

export default component.exports